import { DynamicFormV2Palette } from "@mui/material";

export type FormAvatarComponentTokenType = {
  fallbackBackgroundColor: string;
  fallbackIconColor: string;
};

export const assignAvatarComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDullMode: boolean
) => {
  const isLightMode = mode === "light";

  return {
    fallbackBackgroundColor: isLightMode || isDullMode ? formsPalette.surface.quiet : formsPalette.surface.supershy,
    fallbackIconColor: isLightMode || isDullMode ? formsPalette.surface.moderate : formsPalette.text.moderate,
  } as FormAvatarComponentTokenType;
};
